import React from 'react'
import { DEFAULT_IDEATION_COLUMN_IDS, IDEATION_TABLE_SCOPE } from '../ActivityTable.constants'
import ActivityTabTable, { ActivityTabTableProps } from '../components/ActivityTabTable'

type IdeationTableProps = Pick<ActivityTabTableProps, 'rows' | 'onOpenPanel' | 'onReorder'> & {
    singularActivityLabel: string
}

export const IdeationTable = ({ singularActivityLabel, ...props }: IdeationTableProps) => (
    <ActivityTabTable
        {...props}
        scope={IDEATION_TABLE_SCOPE}
        defaultColumnIds={DEFAULT_IDEATION_COLUMN_IDS}
        searchPlaceholder="Ideation Search"
        noMatchesLabel="ideas"
        emptyTitle="No ideas to display"
        emptySubtitle={`Ideas are ${singularActivityLabel.toLowerCase()} records with an Ideation status`}
    />
)

export default IdeationTable
